import { queryKeys } from "~/v2/api/queryKeys";

interface AtdReplacementChainQueryKeyParams {
  accountID: string;
  product?: "live" | "paper";
  selectedOrderID: string;
  selectedVersion: string;
}

export const atdReplacementChainQueryKeys = {
  all: [...queryKeys.orders.all, "replacement-chain"] as const,
  detail: ({
    accountID,
    product,
    selectedOrderID,
    selectedVersion,
  }: AtdReplacementChainQueryKeyParams) =>
    [
      ...atdReplacementChainQueryKeys.all,
      accountID,
      selectedOrderID,
      product,
      selectedVersion,
    ] as const,
};
